import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NameContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'row',
	wordBreak: 'break-word',
	wordWrap: 'break-word',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	marginLeft: token('space.075'),
	width: '24px',
	height: '24px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: '24px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > span': {
		height: '16px',
		width: '16px',
	},
});
